import React, { useCallback, useState } from 'react';
import { RoadsideAssistanceButton } from '@components/RoadsideAssistanceButton/RoadsideAssistanceButton';
import useSelector from '../../redux/typedHooks';
import { MobileMenuGroup } from './MobileMenuGroup/MobileMenuGroup';
import { MobileHighlightedLink } from './MobileMenuLink/MobileHighlightedLink';
import * as S from './MobileMenuOverlay.styles';

interface MobileMenuOverlayProps {
  isMenuOpen?: boolean;
}

const MobileMenuOverlay = ({ isMenuOpen }: MobileMenuOverlayProps) => {
  const [expandedGroupIndexes, setExpandedGroupIndexes] = useState<number[]>([]);
  const mobileLinks = useSelector((state) => state.globalSettings.settings?.mobileLinks?.items);
  const highlightedLinksMobile = useSelector((state) => state.globalSettings.settings?.highlightedLinksMobile);
  const systemMessage = useSelector((state) => state.globalSettings.settings?.announcement);
  const showSystemMessage = useSelector((state) => state.user.showSystemMessage);

  const toggleGroup = useCallback((index: number) => {
    setExpandedGroupIndexes((currentIndexes) =>
      currentIndexes.includes(index)
        ? currentIndexes.filter((currentIndex) => currentIndex !== index)
        : [...currentIndexes, index],
    );
  }, []);

  const collapseGroups = useCallback(() => {
    setExpandedGroupIndexes([]);
  }, []);

  if (!mobileLinks?.length && !highlightedLinksMobile?.length) {
    return null;
  }

  return (
    <S.Wrapper id="site-mobile-menu" aria-label="Mobil hovedmeny" $isMenuOpen={isMenuOpen}>
      <S.Content $isSystemMessageActive={!!systemMessage && showSystemMessage}>
        {mobileLinks?.map((group, index) => (
          <MobileMenuGroup
            key={group?.header ?? index}
            group={group}
            index={index}
            isExpanded={expandedGroupIndexes.includes(index)}
            onToggle={toggleGroup}
            onLinkClick={collapseGroups}
          />
        ))}
        {highlightedLinksMobile?.length ? (
          <S.HighlightedLinks>
            {highlightedLinksMobile.map((item, index) => (
              <MobileHighlightedLink key={item?.key ?? item?.link?.header ?? index} item={item} />
            ))}
          </S.HighlightedLinks>
        ) : null}
        <S.RoadsideAssistanceButtonWrapper>
          <RoadsideAssistanceButton />
        </S.RoadsideAssistanceButtonWrapper>
      </S.Content>
    </S.Wrapper>
  );
};

export default MobileMenuOverlay;
